import { LineItem } from "@app/scripts/types";
import React from "react";

type Props = {
  lineItem: LineItem;
};

export const CartProductDiscount: React.FC<Props> = ({ lineItem }) =>
  lineItem?.discounts?.length > 0 ? (
    <div className="cart__line-item__discount-wrap">
      {lineItem.discounts.map((discount) => (
        <div className="text-brand-red cart__line-item__discount" data-discount-badge-color={discount?.title?.toLowerCase()}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={14}
            height={14}
            viewBox="0 0 14 14"
            focusable="false"
            aria-hidden="true">
            <path
              d="M7.3,1.4h5c0.2,0,0.4,0.2,0.4,0.3c0,0,0,0,0,0v5c0,0.2-0.1,0.4-0.2,0.5l-4.9,4.9c-0.3,0.3-0.7,0.3-1,0c0,0,0,0,0,0L1.9,7.5c-0.3-0.3-0.3-0.7,0-1c0,0,0,0,0,0l4.9-4.9C6.9,1.5,7.1,1.4,7.3,1.4L7.3,1.4z M9.1,4.2c-0.4,0-0.7,0.3-0.7,0.7s0.3,0.7,0.7,0.7s0.7-0.3,0.7-0.7S9.5,4.2,9.1,4.2z"
              fill="currentColor"
            />
          </svg>
          <span>{discount.title}</span>
        </div>
      ))}
    </div>
  ) : null;
